import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { DepartmentOfEducationAndTraining } from 'src/app/model/organization/department-of-educatio-and-training.model';
import { UtilsService } from '../utils.service';

@Injectable({ providedIn: 'root' })
export class DepartmentOfEducationAndTrainingService {
    httpOptions = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json; charset=utf-8'
        })
    };
    version = 'v1.0';
    url = environment.apiUrl + this.version + '/DepartmentOfEducationAndTraining';
    constructor(
        private http: HttpClient,
        public utilsService: UtilsService,) {
    }

    getAll(filter: any): Observable<any> {
        let queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
        return this.http.get(this.url + '/Get?' + queryString);
    }
    getById(id: any): Observable<any> {
        return this.http.get(this.url + `/GetById/${id}`, this.httpOptions);
    }
    GetSelectPagingById(id: any): Observable<any> {
        return this.http.get(this.url + `/GetSelectPagingById/${id}`, this.httpOptions);
    }

    getSelectPaging(filter: any): Observable<any> {
        let queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
        return this.http.get(this.url + '/GetSelectPaging?' + queryString);
    }
    
    GetSelectPagingBySub(filter?: any): Observable<any> {
        let queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
        return this.http.get(this.url + '/GetSelectPagingBySub?' + queryString);
    }

    getSelectPagingSoByProvince(filter: any): Observable<any> {
        let queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
        return this.http.get(this.url + '/GetSelectPagingSoByProvince?' + queryString);
    }
    getSelectPagingSoByOrganization(filter: any): Observable<any> {
        let queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
        return this.http.get(this.url + '/GetSelectPagingSoByOrganization?' + queryString);
    }

    getSelectPagingByUserLogin(filter: any): Observable<any> {
        let queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
        return this.http.get(this.url + '/GetSelectPagingByUserLogin?' + queryString);
    }

    addOrUpdate(model): Observable<any> {
        if (model.id == 0 || model.id == undefined) {
            model.password = this.utilsService.md5Encode(model.password).toUpperCase();
            return this.http.post(this.url + '/Add', model, this.httpOptions);
        } else {
            return this.http.put(this.url + `/Update/${model.id}`, model, this.httpOptions);
        }
    }

    delete(id: number): Observable<any> {
        return this.http.delete(this.url + `/Delete/${id}`, this.httpOptions);
    }

    deleteMulti(listId: any): Observable<any> {
        return this.http.post(this.url + `/DeleteMulti`, listId, this.httpOptions);
    }
    exportExcel(filter: any): Observable<any> {
        filter = JSON.parse(JSON.stringify(filter));
        delete filter.PageIndex; delete filter.PageSize; 
        let queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
        return this.http.get(this.url + '/GetSelectPagingExport?' + queryString, { responseType: 'blob' as 'json' });
    }
}
